import { useTranslation } from 'react-i18next';
import { useAuthData } from '@anytag/auth';
import { formatIntNumber } from '@anytag/shared-utils';
import { RangeSliderInputField } from '@anytag/shared-molecules';
import { MIN_MAX_PRICE_OPTIONS, MIN_PRICE, MAX_PRICE } from '@anytag/shared-constants';
import { InfluencersFilterFormKeys } from '../schemaTypes';

export const VideoPostPriceField = () => {
  const {
    auth: { currencyId }
  } = useAuthData();
  const { t } = useTranslation();

  return (
    <RangeSliderInputField<InfluencersFilterFormKeys>
      title={t('Video Post Price')}
      options={MIN_MAX_PRICE_OPTIONS}
      slideProps={{ step: 10000, min: MIN_PRICE, max: MAX_PRICE }}
      minField={{ name: 'minVideoPrice', placeholder: `${formatIntNumber(MIN_PRICE)} ${currencyId}` }}
      maxField={{ name: 'maxVideoPrice', placeholder: `${formatIntNumber(MAX_PRICE)}+ ${currencyId}` }}
    />
  );
};
